module.exports = __webpack_public_path__ + "static/media/calender-empty.c2783c7e.svg";